export default __webpack_public_path__ + "static/media/banner_2.22037ab9.jpg";